import {
  Editor_default
} from "./chunk-UW3XDKYU.mjs";
import "./chunk-XJWZA7KQ.mjs";
import {
  SelectionText
} from "./chunk-W2BRCVY6.mjs";
import "./chunk-PW2VLYXQ.mjs";
import "./chunk-ZOV2YOCF.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/index.tsx
import React from "react";
import rehypePrism from "rehype-prism-plus";
import { jsx } from "react/jsx-runtime";
var src_default = React.forwardRef((props, ref) => {
  const _a = props, { rehypePlugins = [[rehypePrism, { ignoreMissing: true }]] } = _a, reset = __objRest(_a, ["rehypePlugins"]);
  return /* @__PURE__ */ jsx(Editor_default, __spreadProps(__spreadValues({}, reset), { rehypePlugins, ref }));
});
export {
  SelectionText,
  src_default as default
};
//# sourceMappingURL=index.mjs.map